import slice from './slice';

export default function (fn) {
    return function (/*...args, callback*/) {
        var args = slice(arguments);
        var callback = args.pop();
        fn.call(this, args, callback);
    };
}



// WEBPACK FOOTER //
// ../../../../node_modules/async-es/internal/initialParams.js